<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Client Amendment</span>
        </div>
    </div>
    <div class="card card_content">
        <div class="cssmtgb just_center">
            <mat-tab-group animationDuration="1000ms" mat-stretch-tabs mat-align-tabs="start"
                (selectedTabChange)="onTabChange($event)">
                <mat-tab label="Amend Customer">
                    <form [formGroup]="form">
                        <div class="row">
                            <div class="col-3"></div>
                            <div class="col-sm-12 col-xl-4 mt-4 d-flex padd-right-file">
                                <mat-form-field appearance="fill" hideRequiredMarker
                                class="searchText-mat-field" style="flex-grow: 1; ">
                                    <mat-label>Email</mat-label>
                                    <input matInput formControlName="email"
                                        placeholder="Enter customer email address here..." required class="col-12"
                                        pattern="^[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,15})$"
                                        autocomplete="off">
                                </mat-form-field>
                                <button mat-icon-button aria-label="Search"
                                class="badge bg-light-blue image-button" (click)="searchbyemail()">
                                <mat-icon style="color: white;">search</mat-icon>
                            </button>
                            </div>

                            <div class="col-xl-4" style="height: fit-content;align-self: end;">
                                <button class="btn reset_btn mt-2" (click)="refreshCustomer()">
                                    <i class="fa fa-refresh"></i> Reset
                                </button>
                            </div>
                        </div>
                    </form>
                    <div class="container p-0" *ngIf="amendcustomer">
                        <div class="card mt-4">
                            <form [formGroup]="customerDetails">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Customer Number</mat-label>
                                            <input matInput  maxlength="25" formControlName="refrenceNumber"
                                                placeholder="Enter Customer Number" class="col-12" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>First Name</mat-label>
                                            <input matInput appInputtext maxlength="25" formControlName="firstName"
                                                placeholder="Enter First Name" required class="col-12"
                                                autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Last Name</mat-label>
                                            <input matInput formControlName="lastName" maxlength="25"
                                                placeholder="Enter Last Name" required class="col-12"
                                                autocomplete="off">
                                        </mat-form-field>
                                    </div>

                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Email</mat-label>
                                            <input matInput formControlName="email" placeholder="Enter Email" required
                                                class="col-12"
                                                pattern="^[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,15})$"
                                                autocomplete="off">
                                        </mat-form-field>
                                    </div>

                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Identification Number</mat-label>
                                            <input matInput formControlName="identificationNumber" maxlength="13"
                                                placeholder="Enter Identification Number" class="col-12"
                                                autocomplete="off">
                                        </mat-form-field>
                                    </div>

                                    <div class="col-sm-12 col-md-6 mt-4 " style="display: flex;">
                                        <div class="css27">
                                            <mat-form-field appearance="fill" hideRequiredMarker
                                                style="width: 60px !important;">
                                                <mat-label>+27</mat-label>
                                                <input readonly class="form-control" matInput maxlength="10" type="text"
                                                    id="mobileNumberLabel" placeholder="+27"
                                                    formControlName="mobileNumberLabel" autocomplete="off"
                                                    class="col-12">
                                            </mat-form-field>
                                        </div>
                                        <div class="css272" style="width: 100%;">
                                            <mat-form-field appearance="fill" hideRequiredMarker>
                                                <mat-label>Cell Number</mat-label>
                                                <input class="form-control" matInput maxlength="9" type="text"
                                                    id="mobileNumber" placeholder="Enter Cell Number"
                                                    formControlName="mobileNumber"
                                                    (input)="onInputChangeLandLineNo('mobileNumber');onInput($event,'/^[0-9]*$/')"
                                                    (keypress)="onlyNumberKey($event)" autocomplete="off" (blur)="lencondition('mobileNumber')"
                                                    class="col-12">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4 " style="display: flex;">
                                        <div class="css27">
                                            <mat-form-field appearance="fill" hideRequiredMarker
                                                style="width: 60px !important;">
                                                <mat-label>+27</mat-label>
                                                <input matInput maxlength="10" type="text" id="PrimaryContactlabel"
                                                    placeholder="+27" formControlName="landLineNumberlabel"
                                                    autocomplete="off" class="col-12" readonly>
                                            </mat-form-field>
                                        </div>
                                        <div class="css272" style="width: 100%;">
                                            <mat-form-field appearance="fill" hideRequiredMarker>
                                                <mat-label>Landline Number (Optional)</mat-label>
                                                <input matInput maxlength="9" type="text" id="landLineNumber"
                                                    placeholder="Enter Landline Number" formControlName="landLineNumber"
                                                    autocomplete="off" class="col-12"
                                                    (input)="onInputChangeLandLineNo('landLineNumber');onInput($event,'/^[0-9]*$/')"
                                                    (keypress)="onlyNumberKey($event)">
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="col-sm-12 col-md-6 mt-4 date_picker">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Date of Birth</mat-label>
                                            <input readonly matInput  [matDatepicker]="dateOfBirth"
                                                id="dateOfBirth" formControlName="dateOfBirth" autocomplete="off"
                                                placeholder="Enter Date of Birth" [min]="minDate" [max]="maxDate"
                                                class="col-12" class="custom-input-border" specialIsAlphaNumeric
                                                required (click)="openDatePicker()">
                                            <span class="" style="position: absolute;right: 3%;top: -2%;">
                                                <i class="far fa-calendar-alt" (click)="openDatePicker()"
                                                    style="color: #690194;"></i>
                                            </span>
                                            <mat-datepicker #dateOfBirth></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="float-right button-style mt-4">
                            <button class="btn btn-secondary mb-3 mr-2" type="submit" (click)="submitAmendCustomer()"
                                matButton>Submit</button>
                            <button class="btn reset_btn mb-3 mr-2" type="submit" (click)="resetPassword()"
                                matButton>Reset Password</button>
                            <button class="btn balance_btn mb-3" type="submit" (click)="clearBalance()" matButton>Clear
                                Balance</button>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Amend Address">
                    <form [formGroup]="form">
                        <div class="row">
                            <div class="col-3"></div>
                            <div class="col-sm-12 col-xl-4 mt-4 d-flex padd-right-file">
                                <mat-form-field appearance="fill" hideRequiredMarker
                                class="searchText-mat-field" style="flex-grow: 1; ">
                                    <mat-label>Application</mat-label>
                                    <input matInput formControlName="application"
                                        placeholder="Enter application number here..." required class="col-12"
                                        maxlength="50" autocomplete="off">
                                </mat-form-field>
                                <button mat-icon-button aria-label="Search"
                                class="badge bg-light-blue image-button" (click)="searchbyapplication()">
                                <mat-icon style="color: white;">search</mat-icon>
                            </button>
                            </div>
                            <div class="col-xl-4" style="height: fit-content;align-self: end;">
                                <!-- <button class="btn reset_btn mt-2" (click)="refreshCustomer()">
                                    <i class="fa fa-refresh"></i> Refresh
                                </button> -->
                                <app-button (refreshClicked)="refreshCustomer()"></app-button>

                            </div>
                        </div>
                    </form>

                    <div class="container p-0" *ngIf="amendaddress">
                        <div class="card mt-4">
                            <form [formGroup]="amendAddressForm">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Address Line 1</mat-label>
                                            <input matInput  formControlName="addressLine1"
                                                placeholder="Enter Address Line 1" class="col-12" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Address Line 2</mat-label>
                                            <input matInput   formControlName="addressLine2"
                                                placeholder="Enter Address Line 2" class="col-12" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>City</mat-label>
                                            <input matInput appInputtext maxlength="50" formControlName="city"
                                                placeholder="Enter City" class="col-12" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Region</mat-label>
                                            <input matInput appInputtext maxlength="50" formControlName="region"
                                                placeholder="Enter Region" class="col-12" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="float-right button-style mt-4">
                            <button class="btn btn-secondary mb-3 mr-2" type="submit" (click)="submitAmendAddress()"
                                matButton>Submit
                            </button>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Bank Account Verification">
                    <div class="container p-0">
                        <div class="card mt-4">
                            <form [formGroup]="accountVerificationForm">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Bank</mat-label>
                                            <mat-select class="scrollbarcs" formControlName="BankCode"
                                                (selectionChange)="onTechNameChange($event)" placeholder="Select the Bank">
                                                <mat-select-filter [displayMember]="'value'" [array]="BankList"
                                                    (filteredReturn)="filterBankList = $event"></mat-select-filter>
                                                <mat-option *ngFor="let rolltype of filterBankList"
                                                    [value]="rolltype.key" required
                                                    style="overflow-y: scroll !important;">
                                                    {{ rolltype.value }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4 d-flex align-items-center">
                                      <span class="mr-3"> Bank Account Verification</span>
                                        <mat-label class="mx-3" style="color:#7f15d1" *ngIf="!this.accountVerificationForm.value.accountStatusMode">Off</mat-label>
                                        <mat-slide-toggle formControlName="accountStatusMode" color="primary" (change)="saveAccountVerificationStatus($event)">
                                        <mat-label class="mx-3" style="color:black" *ngIf="this.accountVerificationForm.value.accountStatusMode"> ON </mat-label>
                                        </mat-slide-toggle>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Branch Code</mat-label>
                                            <input matInput  maxlength="50" formControlName="BranchCode"
                                                placeholder="Enter Branch Code" class="col-12" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Account Number</mat-label>
                                            <input matInput (keypress)="restrictSpace($event)" maxlength="50" formControlName="AccountNumber"
                                                placeholder="Enter Account Number" class="col-12" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Account Type</mat-label>
                                            <mat-select class="scrollbarcs" formControlName="AccountType" placeholder="Select Account Type">
                                                <mat-select-filter [displayMember]="'value'" [array]="AccountTypeList"
                                                    (filteredReturn)="filterAccountTypeList = $event"></mat-select-filter>
                                                <mat-option *ngFor="let rolltype of filterAccountTypeList"
                                                    [value]="rolltype.key" required
                                                    style="overflow-y: scroll !important;">
                                                    {{ rolltype.value }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="float-right button-style mt-4">
                            <button class="btn btn-secondary mb-3 mr-2" type="submit"
                                (click)="submitAccountVerification()" matButton>Submit
                            </button>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Amend Billing Information">
                    <form [formGroup]="form">
                        <div class="row d-flex justify-content-center">
                            <div class="col-sm-12 col-xl-4 mt-4 d-flex padd-right-file">
                                <mat-form-field appearance="fill" hideRequiredMarker
                                class="searchText-mat-field" style="flex-grow: 1; ">
                                    <mat-label>Reference Number</mat-label>
                                    <input matInput formControlName="referenceNumber"
                                        placeholder="Enter user reference number here..." required class="col-12"
                                        maxlength="50" autocomplete="off">
                                </mat-form-field>
                                <button mat-icon-button aria-label="Search"
                                class="badge bg-light-blue image-button" (click)="searchBillingInformation()">
                                <mat-icon style="color: white;">search</mat-icon>
                            </button>
                            </div>
                            <div class="col-xl-2" style="height: fit-content;align-self: end;">
                                <button class="btn reset_btn mt-2" (click)="refreshCustomer()">
                                    <i class="fa fa-refresh"></i> Reset
                                </button>
                            </div>
                            <div class="col-xl-4 h5_header mt-3 mb-1" style="font-size: x-large;align-self: end;" *ngIf="billingInfoFormGroup.value.customerName"> 
                             Name :   {{billingInfoFormGroup.value.customerName}}
                            </div>
                        </div>
                    </form>
                    <form [formGroup]="billingInfoFormGroup" *ngIf="billlingInformation">
                        <div class="container p-0">
                            <div class="card my-4">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6">
                                        <div class="col-12 pl-1">
                                            <h5 class="h5_header mb-0 mt-2" style="color: #444444;">Mailing Address</h5>
                                        </div>
                                        <div class="padd-right-file  mt-4" style="display: flex;">
                                            <mat-form-field appearance="fill" hideRequiredMarker>
                                                <mat-label>Company Name / Address 1</mat-label>
                                                <input matInput  formControlName="address1"
                                                    class="col-10" placeholder="Enter Company Name / Address 1" required
                                                    autocomplete="off">
                                            </mat-form-field>
                                            <button type="button" (click)="setToDelivery()" mat-raised-button
                                                matTooltip="Copy mailing address to delivery address"
                                                matTooltipClass="sidebar_tooltip"
                                                class="badge bg-light-blue move_right_button">
                                                <img style="transform: rotate(180deg) translate(0%, 0%);width: 22px;filter: invert(1);"
                                                    src="../../../../assets/Home-Connect/icons/arrow.svg" />
                                            </button>
                                        </div>
                                        <mat-form-field appearance="fill" hideRequiredMarker class="mt-4">
                                            <mat-label>Address 2</mat-label>
                                            <input matInput formControlName="address2"
                                                class="col-10" placeholder="Enter Address 2" autocomplete="off">
                                        </mat-form-field>
                                        <mat-form-field appearance="fill" hideRequiredMarker class="mt-4">
                                            <mat-label>Address 3</mat-label>
                                            <input matInput  maxlength="25" formControlName="address3"
                                                class="col-10" placeholder="Enter Address 3" autocomplete="off">
                                        </mat-form-field>
                                        <mat-form-field appearance="fill" hideRequiredMarker class="mt-4">
                                            <mat-label>City</mat-label>
                                            <input matInput appInputtext maxlength="25" formControlName="mailingCity"
                                                class="col-10" placeholder="Enter City" autocomplete="off">
                                        </mat-form-field>
                                        <mat-form-field appearance="fill" hideRequiredMarker class="mt-4">
                                            <mat-label>Province</mat-label>
                                            <mat-select class="scrollbarcs" formControlName="mailingState">
                                                <mat-select-filter [displayMember]="'value'" [array]="mail"
                                                    (filteredReturn)="filteredList = $event"></mat-select-filter>
                                                <mat-option *ngFor="let mailtype of filteredList" [value]="mailtype.key"
                                                    style="overflow-y: scroll !important;">
                                                    {{ mailtype.value }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field appearance="fill" hideRequiredMarker class="mt-4">
                                            <mat-label>
                                                Post Code
                                            </mat-label>
                                            <input matInput  maxlength="25"
                                                formControlName="mailingPostCode" class="col-10"
                                                placeholder="Enter Post Code" autocomplete="off">
                                        </mat-form-field>
                                        <mat-form-field appearance="fill" hideRequiredMarker class="mt-4">
                                            <mat-label>
                                                Country
                                            </mat-label>
                                            <input matInput appInputtext maxlength="25" formControlName="mailingCountry"
                                                class="col-10" placeholder="Enter Country" autocomplete="off" readonly value="South Africa">
                                        </mat-form-field>
                                        <mat-form-field appearance="fill" hideRequiredMarker class="mt-4">
                                            <mat-label>
                                                VAT Number
                                            </mat-label>
                                            <input matInput  maxlength="25" formControlName="vatNumber"
                                                class="col-10" placeholder="Enter VAT Number" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6">
                                        <div class="col-12 pl-1">
                                            <h5 class="h5_header mb-0 mt-2" style="color: #444444;">Delivery Address
                                            </h5>
                                        </div>
                                        <mat-form-field appearance="fill" hideRequiredMarker class="mt-4">
                                            <mat-label> Company Name / Delivery Address 1</mat-label>
                                            <input matInput  formControlName="delivery1"
                                                class="col-10" required
                                                placeholder="Enter Company Name / Delivery Address 1"
                                                autocomplete="off">
                                        </mat-form-field>
                                        <mat-form-field appearance="fill" hideRequiredMarker class="mt-4">
                                            <mat-label>
                                                Delivery Address 2
                                            </mat-label>
                                            <input matInput  formControlName="delivery2"
                                                class="col-10" placeholder="Enter Delivery Address 2"
                                                autocomplete="off">
                                        </mat-form-field>
                                        <mat-form-field appearance="fill" hideRequiredMarker class="mt-4">
                                            <mat-label>
                                                Delivery Address 3
                                            </mat-label>
                                            <input matInput  maxlength="25" formControlName="delivery3"
                                                class="col-10" placeholder="Enter Delivery Address 3"
                                                autocomplete="off">
                                        </mat-form-field>
                                        <mat-form-field appearance="fill" hideRequiredMarker class="mt-4">
                                            <mat-label>
                                                City
                                            </mat-label>
                                            <input matInput appInputtext maxlength="25" formControlName="deliveryCity"
                                                class="col-10" placeholder="Enter City" autocomplete="off">
                                        </mat-form-field>
                                        <mat-form-field appearance="fill" hideRequiredMarker class="mt-4">
                                            <mat-label>Province</mat-label>
                                            <mat-select class="scrollbarcs" formControlName="deliveryState">
                                                <mat-select-filter [displayMember]="'value'" [array]="mail"
                                                    (filteredReturn)="filteredList = $event"></mat-select-filter>
                                                <mat-option *ngFor="let mailtype of filteredList" [value]="mailtype.key"
                                                    style="overflow-y: scroll !important;">
                                                    {{ mailtype.value }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field appearance="fill" hideRequiredMarker class="mt-4">
                                            <mat-label>
                                                Post Code
                                            </mat-label>
                                            <input matInput  maxlength="25"
                                                formControlName="deliveryPostCode" class="col-10"
                                                placeholder="Enter Post Code" autocomplete="off">
                                        </mat-form-field>
                                        <mat-form-field appearance="fill" hideRequiredMarker class="mt-4">
                                            <mat-label>
                                                Country
                                            </mat-label>
                                            <input matInput appInputtext maxlength="25"
                                                formControlName="deliveryCountry" class="col-10"
                                                placeholder="Enter Country" autocomplete="off" readonly value="South Africa">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container p-0">
                            <div class="card">

                                <h3 class="step-title">
                                    <span class="part-one">Contact Information</span>
                                </h3>

                                <div class="col-12 pl-1">
                                    <h5 class="h5_header mb-0 mt-2" style="color: #444444;">Contact 1</h5>
                                </div>
                                <ng-container>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-6 mt-4">
                                            <mat-form-field appearance="fill" hideRequiredMarker>
                                                <mat-label>Contact Name</mat-label>
                                                <input matInput appInputtext maxlength="30" formControlName="contact"
                                                    required placeholder="Enter Contact Name" class="col-10"
                                                    autocomplete="off">
                                            </mat-form-field>
                                        </div>
                                        <div class="col-sm-12 col-md-6 mt-4" style="display: flex;">
                                            <div class="css27">
                                                <mat-form-field class="po-none" appearance="fill" hideRequiredMarker
                                                    style="width: 60px !important;">
                                                    <mat-label>+27</mat-label>
                                                    <input class="form-control" matInput maxlength="9" minlength="9" type="text"
                                                        id="PrimaryContactlabel" placeholder="+27"
                                                        formControlName="contactCell27" autocomplete="off"
                                                        class="col-12" readonly>
                                                </mat-form-field>
                                            </div>
                                            <div class="css272" style="width: 100%;">
                                                <mat-form-field appearance="fill" hideRequiredMarker>
                                                    <mat-label>Contact Cell</mat-label>
                                                    <input class="form-control" matInput maxlength="9" minlength="9" type="text"
                                                        id="contactCell" placeholder="Enter Contact Cell"
                                                        formControlName="contactCell" autocomplete="off" class="col-12"
                                                        (input)="onInputChangeLandLineNoB('contactCell');onInput($event,'/^[0-9]*$/')">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-6 mt-4">
                                            <mat-form-field appearance="fill" hideRequiredMarker>
                                                <mat-label>Contact Email</mat-label>
                                                <input matInput  maxlength="100" formControlName="eMail"
                                                pattern="^[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,15})$"
                                                    class="col-10" required placeholder="Enter Contact Email"
                                                    autocomplete="off">
                                            </mat-form-field>
                                        </div>
                                        <div class="col-sm-12 col-md-6 mt-4">
                                            <mat-form-field appearance="fill" hideRequiredMarker>
                                                <mat-label>Role</mat-label>
                                                <mat-select class="scrollbarcs" formControlName="role">
                                                    <mat-select-filter [displayMember]="'value'" [array]="roll"
                                                        (filteredReturn)="filteredList2 = $event"></mat-select-filter>
                                                    <mat-option *ngFor="let rolltype of filteredList2"
                                                        [value]="rolltype.key" required
                                                        style="overflow-y: scroll !important;">
                                                        {{ rolltype.value }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </ng-container>

                                <div class="line"></div>
                                <div class="col-12 pl-1">
                                    <h5 class="h5_header mb-0 mt-4" style="color: #444444;">Contact 2</h5>
                                </div>
                                <ng-container>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-6 mt-4">
                                            <mat-form-field appearance="fill" hideRequiredMarker>
                                                <mat-label>Contact Name</mat-label>
                                                <input matInput appInputtext maxlength="30" formControlName="contact2"
                                                    class="col-10" placeholder="Enter Contact Name" autocomplete="off">
                                            </mat-form-field>
                                        </div>

                                        <div class="col-sm-12 col-md-6 mt-4" style="display: flex;">
                                            <div class="css27">
                                                <mat-form-field class="po-none" appearance="fill" hideRequiredMarker
                                                    style="width: 60px !important;">
                                                    <mat-label>+27</mat-label>
                                                    <input class="form-control" matInput maxlength="9" type="text"
                                                        id="PrimaryContactlabel" placeholder="+27"
                                                        formControlName="contactCell227" autocomplete="off"
                                                        class="col-12" readonly>
                                                </mat-form-field>
                                            </div>
                                            <div class="css272" style="width: 100%;">
                                                <mat-form-field appearance="fill" hideRequiredMarker>
                                                    <mat-label>Contact Cell</mat-label>
                                                    <input class="form-control" matInput minlength="9"  maxlength="9" type="text"
                                                        id="contactCell2" placeholder="Enter Contact Cell"
                                                        formControlName="contactCell2" autocomplete="off" class="col-12"
                                                        (input)="onInputChangeLandLineNoB('contactCell2');onInput($event,'/^[0-9]*$/')">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-6 mt-4">
                                            <mat-form-field appearance="fill" hideRequiredMarker>
                                                <mat-label>Contact Email</mat-label>
                                                <input matInput  maxlength="100" formControlName="eMail2"
                                                pattern="^[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,15})$"
                                                    class="col-10" placeholder="Enter Contact Email" autocomplete="off">
                                            </mat-form-field>
                                        </div>
                                        <div class="col-sm-12 col-md-6 mt-4">
                                            <mat-form-field appearance="fill" hideRequiredMarker>
                                                <mat-label>Role</mat-label>
                                                <mat-select class="scrollbarcs" formControlName="role2">
                                                    <mat-select-filter [displayMember]="'value'" [array]="roll"
                                                        (filteredReturn)="filteredList2 = $event"></mat-select-filter>
                                                    <mat-option *ngFor="let rolltype of filteredList2"
                                                        [value]="rolltype.key" style="overflow-y: scroll !important;">
                                                        {{ rolltype.value }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <div class="float-right button-style mt-4">
                            <button class="btn btn-secondary mb-3 mr-2" type="submit" (click)="submitUserBilling()"
                                matButton>Submit
                            </button>
                        </div>
                    </form>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>
